import heroImage from '~/assets/hero.webp'
import { m } from '~/paraglide/messages'

export function HeroSection() {
  return (
    <div class="flex flex-col items-center gap-[18px]">
      <div class="relative z-0 mb-[-45px] h-[222px] w-full overflow-visible">
        <img
          src={heroImage}
          alt=""
          class="pointer-events-none absolute inset-x-0 top-1/2 aspect-[760/354] -translate-y-1/2 scale-[1.2] select-none object-cover"
        />
      </div>
      <div class="relative z-10 flex flex-col items-center gap-[5px] px-6">
        <h1 class="text-center text-2xl font-bold text-ink">
          {m.invite_page_title()}
        </h1>
        <p class="max-w-[305px] text-center text-sm text-moss">
          {m.invite_page_subtitle()}
        </p>
      </div>
    </div>
  )
}
